import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/service/api.service';
import { ExcelService } from 'src/app/service/excel.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { numValidation } from 'src/app/service/customValidation';
import { DataPassingService } from 'src/app/service/data-passing.service';
import { DatePipe } from '@angular/common';

export interface StandardElement {
  name: string;
  dueAmount: string;
}

@Component({
  selector: 'app-refund-list',
  templateUrl: './refund-list.component.html',
  styleUrls: ['./refund-list.component.css']
})
export class RefundListComponent implements OnInit {

  displayedColumns: string[] = ['name','date','dueAmount','cd'];
  dataSource:MatTableDataSource<any>=new MatTableDataSource();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  tblLoading=false;
  itemTotal=0;
  message='';
  selectFormGroup:FormGroup;
  isSuccess=false;
  isError=false;
  isSubmitted=false;
  isDisabled=false;
  year=0;
  public totals:any;

  constructor(private api:ApiService,private route:ActivatedRoute,private excelService:ExcelService,private formBuilder:FormBuilder,public dialog: MatDialog,private dataPass:DataPassingService,private router:Router) {
    this.selectFormGroup=this.formBuilder.group({
      year:['',[Validators.required,numValidation()]]
    });
   }

  ngOnInit() {
    this.totals=[];
    this.route.data.subscribe(data=>{
      this.itemTotal=parseInt(data.refund[0].total);
      this.dataSource.data=data.refund[0].data;
    },(error)=>{

    });
  }

  print()
  {
    window.print();
  }

  onView(e,id)
  {
    e.preventDefault();
    const dialogRef = this.dialog.open(DialogOldStudent,{
      data: {
        id:id
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      
    });
  }

  fetchRefundList(form)
  {
    this.isSubmitted=true;
    this.year=form.value.year;
  this.refreshTable(0,10,this.year);
  }

  tblItmPageChange(event)
  {
    let start=(event.pageIndex>0)?(event.pageSize*event.pageIndex):event.pageIndex;
    let postData={start:start,length:event.pageSize};
    this.refreshTable(start,event.pageSize,this.year);
   
  }

  refreshTable(start,pageSize,year)
  {
    this.api.get("refundList?ustatus=0&year="+year+"&orderBy=dueDate_desc&start="+start+"&length="+pageSize).subscribe(data=>{
      this.itemTotal=parseInt(data.total);
      this.dataSource.data=data.data;
      this.totals=data.totals;
    },(error)=>{

    });
  }

  onEdit(id)
  {
    this.dataPass.passDataService({id:id});
    this.router.navigateByUrl("/admin/admission");
  }

  exportAsXLSX():void {
    this.api.get("refundList?ustatus=0&year="+this.year+"&export=excel").subscribe(data=>{
      this.itemTotal=parseInt(data.total);
      data.data.push({"Scholarship":"Totals","BorrowPaid":data.totals.paidAmount,"BorrowRemaining":data.totals.remainingAmount});
      this.excelService.exportAsExcelFile(data.data, 'sample');
    },(error)=>{

    });
    
 }

 searchname(e)
 {
   let url='';
   if(e.target.value.length>1)
   {
    url="refundList?ustatus=0&orderBy=dueDate_desc&start=0&length=10&name="+e.target.value;
   }
   else if(e.target.value.length==0)
   {
     url="refundList?ustatus=0&orderBy=dueDate_desc&start=0&length=10&";
   }

   this.api.get(url).subscribe(data=>{
    this.itemTotal=parseInt(data.total);
    this.dataSource.data=data.data;
  },(error)=>{

  });

}

}

@Component({
  selector: 'dialog-data-example-dialog',
  templateUrl:'../student-list/view-student.html',
  styleUrls: ['../student-list/student-list.component.css'],
})

export class DialogOldStudent {
  public providerAmount=0;
  public totalDonation=0;
  showLoading=true;
  
  public paid=0;
  
  constructor(private dataPass:DataPassingService,private api:ApiService,@Inject(MAT_DIALOG_DATA) public data: any,private datePipe:DatePipe) {
    this.data.donarPayment=[];
    
    this.api.get('studentDetails?usstatus=0&id='+data.id).subscribe(data=>{
     this.data=data.student;
     this.data.studentPayments=data.studentPayments;
     this.data.donarPayments=data.donarPayments;
     this.data.refunds=data.refunds;
     
     if(data.donarPayments!="")
     {
      data.donarPayments.forEach(el => {
        if(el.amount)
        {
          this.totalDonation+=parseInt(el.amount);
        }
         
      });
     }
     
     this.providerAmount=data.donar.provider_amount;
         this.paid=data.donar.paid_amount;
         this.showLoading=false;
        },(error)=>{

        });
       
        
  }

  trustPaid(amount)
  {
    if(amount<=this.totalDonation)
    {
      return 0;
    }
    else if(amount>this.totalDonation)
    {
      return amount-this.totalDonation;
    }
    else
    {
      return amount;
    }
  }

  DonarPaid(amount)
  {
    if(amount<=this.totalDonation)
    {
      return amount;
    }
    else if(amount>this.totalDonation)
    {
      return this.totalDonation;
    }
    else
    {
      return 0;
    }
    
  }

  trust(amount)
  {
    if(amount==undefined)
    {
      return 0;
    }
    else
    {
      return amount;
    }
    
  }

 

  donarPayment(amount,paid,i)
  {
    
    if(paid==undefined)
    {
      paid=0;
      return 0
    }
    else
    {
      if(this.data.donarPayment[i]==undefined)
      {
          return 0;
      }
      else
      {
        if(parseInt(this.data.donarPayment[i].amount)>parseInt(amount))
        {
          return parseInt(amount);
        }
        else{
          return parseInt(amount)-parseInt(this.data.donarPayment[i].amount);
        }
        
      }
      
    }

  }

  
 
  dateValTranform(dt)
  {
    return this.datePipe.transform(dt,"dd/MM/yyyy");
  }

  
  
}
